export default function getclientNameById(
  clientsObj: Record<number, { name?: string }>,
  clientId: number
) {
  console.log("Client IDSSSS", clientId);
  return clientsObj?.[clientId]?.name ?? `#${clientId}`;
}
